// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c214e9d","453":"d1e20502","667":"db212b3c","977":"77a1d3ae"}[chunkId] + ".chunk.js";
};